import React from 'react';

type RatingSource = {
  averageRating?: number | null;
  ratingCount?: number | null;
  AverageRating?: number | null;
  RatingCount?: number | null;
} | null | undefined;

export function readCourseRating(source?: RatingSource) {
  const rec = (source || {}) as Record<string, unknown>;
  const count = Number(rec.ratingCount ?? rec.RatingCount ?? rec.count ?? rec.Count ?? 0) || 0;
  const average = Number(rec.averageRating ?? rec.AverageRating ?? rec.average ?? rec.Average ?? 0) || 0;
  return { average, count: count || (average > 0 ? 1 : 0) };
}

export const formatRating = (average?: number | null, count?: number | null) => {
  const n = Number(count || 0);
  if (n <= 0) return null;
  return `${Number(average || 0).toFixed(1)} (${n})`;
};

const CourseRating: React.FC<{
  average?: number | null;
  count?: number | null;
  className?: string;
  showEmpty?: boolean;
}> = ({ average, count, className, showEmpty = false }) => {
  const n = Number(count || 0);
  const text = n > 0 ? `${Number(average || 0).toFixed(1)} (${n})` : (showEmpty ? 'No ratings yet' : null);
  if (!text) return null;
  return (
    <span className={className || 'text-xs text-amber-700'}>
      ★ {text}
    </span>
  );
};

export default CourseRating;
